/** @jsx jsx */
import { type SerializedStyles, jsx } from '@emotion/react';

import type * as React from 'react';

import type { MerchandisingModule } from '@coursera/event-pulse-types';
import { useVisibilityTracker } from '@coursera/event-pulse/react';

import { BasicCard } from 'bundles/cds-labs/components';

export type TrackedBasicCardEventingData = {
  merchandisingModule: MerchandisingModule;
};

type Props = React.PropsWithChildren<{
  eventingData: TrackedBasicCardEventingData;
  cardStyles: Array<SerializedStyles | string>;
}>;

/** Per-card view tracking, mirroring HeroBentoCard's per-card visibility tracker. */
const TrackedBasicCard = ({ eventingData, cardStyles, children }: Props) => {
  const visibilityTrackingRef: React.MutableRefObject<HTMLDivElement | null> = useVisibilityTracker(
    'view_merchandising_module',
    {
      merchandisingModule: eventingData.merchandisingModule,
    },
    [],
    { fullyVisible: true }
  );

  return (
    <BasicCard ref={visibilityTrackingRef} css={cardStyles}>
      {children}
    </BasicCard>
  );
};

export default TrackedBasicCard;
